module.exports = __webpack_public_path__ + "img/landscape_10.ef5a87b2.jpg";